<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-19 18:30:18
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-08-28 18:29:48
 * @FilePath:
 * @Description: 扫码点单后的点单记录
-->
<template>
  <div class="place_order_con">
    <van-row type="flex" justify="space-between" gutter="20">
      <van-col span="12">
        <van-cell title="桌号" :value="deskCode.code" />
      </van-col>
      <van-col span="12">
        <van-cell title="人数">
          <template #extra>
            <p>{{ orderPeople }}人</p>
          </template>
        </van-cell>
      </van-col>
    </van-row>
    <div class="placeOrderList" v-if="allUnpayedList.length > 0">
      <van-row
        class="title_con"
        type="flex"
        justify="space-between"
        align="center"
      >
        <h3>待支付</h3>
        <van-tabs
          line-width="24px"
          line-height="2px"
          color="#333"
          title-inactive-color="#999"
          title-active-color="#333"
          v-model="tabActive"
        >
          <van-tab
            name="type"
            title="按类型"
            title-class="card_tabs_con"
          ></van-tab>
          <van-tab
            name="time"
            title="按时间"
            title-class="card_tabs_con"
          ></van-tab>
          <!-- <van-tab
            name="people"
            title="按人"
            title-class="card_tabs_con"
          ></van-tab> -->
        </van-tabs>
      </van-row>
      <goodListCard
        :carGoodsList="commodityInformation"
        :allPrice="allPrice"
        :allNum="allNum"
        :showFoodType="true"
        :noRemarkModal="true"
      >
        <template v-slot:mealName="slotDataObj">
          <div class="meal_desc_con">
            <p>{{ slotDataObj.goodsItem.mealNameStr }}</p>
          </div>
        </template>
      </goodListCard>

      <!-- <van-field
        v-model="orderRemark"
        rows="2"
        readonly
        autosize
        label=""
        type="textarea"
      /> -->
    </div>
    <div class="placeOrderList">
      <van-row class="title_con" type="flex" align="center">
        <h3>已支付订单</h3>
      </van-row>

      <ul class="payed_order_list" v-if="payedOrderList.length > 0">
        <li
          v-for="(item, index) in payedOrderList"
          :key="index"
          @click="handleToOrderDetail(item)"
        >
          <van-row
            type="flex"
            justify="space-between"
            class="van-hairline--bottom"
          >
            <p>下单时间：{{ item.CreateTime }}</p>
            <p>{{ item.PayType }}</p>
          </van-row>
          <div class="payed_order_con">
            <div class="order_img_con">
              <p v-for="(imgItem, imgIndex) in item.Details" :key="imgIndex">
                <img
                  v-lazy="
                    imgItem.ProductImage
                      ? imgItem.ProductImage
                      : $root.defaultImg
                  "
                  alt=""
                />
                <span class="c-lightgrey van-ellipsis">{{
                  imgItem.ProductName
                }}</span>
              </p>
            </div>
            <span class="c-lightgrey">
              共{{ handleGetFoodsNum(item.Details) }}份
            </span>
          </div>

          <van-row type="flex" justify="end">
            <p class="small_price_con c-main-txt">
              <span>合计：</span><i class="bold">￥{{ item.OrigMoney }}</i>
            </p>
          </van-row>
        </li>
      </ul>
      <van-empty v-else description="暂无订单" />
    </div>
    <van-popup
      class="shop_cart_con"
      round
      closeable
      v-model="showPayPop"
      position="bottom"
    >
      <div class="cartTitle">
        <span> 支付方式 </span>
      </div>
      <div class="cart_goods_con">
        <PayRadioCom ref="payMethodCom" fromPage="pop"></PayRadioCom>
      </div>
      <van-button
        class="submit_btn"
        size="small"
        color="#333"
        round
        @click="handleSubmitPay"
        :loading="isSubmitLoading"
        loading-text="支付中..."
        >确定</van-button
      >
    </van-popup>
    <div class="history_footer">
      <!-- <div class="money">
        共{{allNum}}份餐品
        合计:<span>￥{{ allPrice }}</span>
      </div> -->
      <van-button color="#333" block plain round @click="handleToMicpoint"
        >继续加菜</van-button
      >
      <span v-if="allUnpayedList.length != 0" style="width: 20px"></span>
      <van-button
        v-if="allUnpayedList.length != 0"
        color="#333"
        block
        round
        @click="handleShowPayPop"
        >立即付款</van-button
      >
    </div>
  </div>
</template>

<script>
import {
  Notify,
  Col,
  Row,
  Cell,
  Field,
  Popup,
  Area,
  Checkbox,
  Dialog,
} from "vant";

import { handleLocalStorage, handleSessionStorage } from "@/utils";
import { mapActions, mapState, mapGetters } from "vuex";
import goodListCard from "@/components/goodsListCard";
import PayRadioCom from "@/components/PayComps";
import { payByhandkey } from "@/api/foodOrder";
export default {
  name: "NewPlaceOrder",
  props: {},
  data() {
    return {
      payedOrderList: [],
      orderRemark: "",
      showPayPop: false,
      tabActive: "type",
      commodityInformation: {},
      allUnpayedList: [],
      isSubmitLoading: false,
    };
  },
  components: {
    goodListCard,
    PayRadioCom,
  },
  computed: {
    ...mapState({
      // cardInfo: (rootState) => rootState.cardInfo,
      // commodityInformation: (rootState) => rootState.shopCart.carGoodsList, //购物车中物品列表
      orderPeople: (rootState) => rootState.order.orderPeople, //人数
    }),
    // ...mapGetters("shopCart", {
    //   allNum: "allNum",
    //   allPrice: "allPrice",
    // }),
    deskCode() {
      const preDeskCode = handleSessionStorage.get("deskCode");
      return (
        preDeskCode || { code: "", depart: "", checkinId: "", cardCode: "" }
      );
    },
    payMethodType() {
      return this.$refs.payMethodCom.payType;
    },
  },
  watch: {
    tabActive(val) {
      this.commodityInformation =
        val == "type"
          ? this.typeFoodsListObj
          : val == "time"
          ? this.timeFoodsListObj
          : this.userFoodsListObj;
    },
  },
  created() {
    const vpnStorage = handleSessionStorage.get("vpnInfo");
    this.vpnId = vpnStorage.id;
    this.handleGetHistoryOrder();
  },
  mounted() {},
  methods: {
    handleGetHistoryOrder() {
      const param = {
        vpnId: this.vpnId,
        keyCode: this.deskCode.cardCode,
        tableCode: this.deskCode.code,
      };
      $http("wechath5/zh-cn/v1/meal/orderlist", param, "get").then((res) => {
        let payedList = [];
        let unPayedList = [];
        res.forEach((item) => {
          if (item.Status == 1 || item.Status == 5) {
            payedList.push(item);
          } else if (item.Status == 0) {
            this.unPayedId = item.Id;
            unPayedList.push(item);
          }
        });
        this.payedOrderList = payedList;
        let allFoodsList = [];
        let allPrice = 0;
        let allNum = 0;
        unPayedList.forEach((item) => {
          allPrice += item.OrigMoney;
          if (item.Details.length > 0) {
            item.Details.forEach((dItems) => {
              allNum += dItems.Quantity;
              allFoodsList.push({
                ProductId: dItems.ProductId,
                GoodsName: dItems.ProductName,
                PicUrl: dItems.ProductImage,
                num: dItems.Quantity,
                Price: dItems.Price,
                Remark: dItems.Remark || "",
                ProductType: dItems.ProductType,
                CreateTime: dItems.CreateTime,
                // Specification: dItems.Specification,
                Name: dItems.Specification, //规格名称
              });
            });
          }
        });
        this.allUnpayedList = allFoodsList;
        // 按人
        this.userFoodsListObj = {
          1: {
            name: "我",
            list: allFoodsList,
            smallPrice: allPrice,
            smallNum: allNum,
          },
        };
        this.allPrice = allPrice;
        this.allNum = allNum;
        this.handleInitShowFoodsListObj();
        // this.orderPeople = res && res[0] && res[0].PersonNum;
      });
    },
    // 初始化三种类型的餐品数据
    handleInitShowFoodsListObj() {
      const typeListObj = {};
      const timeListObj = {};
      this.allUnpayedList.forEach((item) => {
        //按类型
        if (!typeListObj[item.ProductType]) {
          console.log(item.ProductType);
          typeListObj[item.ProductType] = {
            name: item.ProductType,
            list: [item],
            smallPrice: this.$calc.multiply(item.num, item.Price),
            smallNum: item.num,
          };
        } else {
          const listItemObj = typeListObj[item.ProductType].list.find(
            (listItem) =>
              listItem.ProductId == item.ProductId &&
              listItem.Name == item.Name &&
              listItem.Price == item.Price
          );
          if (listItemObj) {
            listItemObj.num += item.num;
            let remarkArr =
              listItemObj.Remark.length > 0
                ? listItemObj.Remark.split(";")
                : [];
            if (item.Remark) remarkArr.push(item.Remark);
            listItemObj.Remark = remarkArr.join(";");
          } else {
            typeListObj[item.ProductType].list.push(item);
          }
          typeListObj[item.ProductType].smallPrice = this.$calc.add(
            typeListObj[item.ProductType].smallPrice,
            this.$calc.multiply(item.num, item.Price)
          );
          // typeListObj[item.ProductType].smallPrice += item.num * item.Price;
          typeListObj[item.ProductType].smallNum += item.num;
        }
        // 按时间
        if (!timeListObj[item.CreateTime]) {
          timeListObj[item.CreateTime] = {
            name: "下单时间：" + item.CreateTime,
            list: [item],
            smallPrice: this.$calc.multiply(item.num, item.Price),
            smallNum: item.num,
          };
        } else {
          const listItemObj = timeListObj[item.CreateTime].list.find(
            (listItem) =>
              listItem.ProductId == item.ProductId &&
              listItem.Name == item.Name &&
              listItem.Price == item.Price
          );
          if (listItemObj) {
            listItemObj.num += item.num;
            let remarkArr =
              listItemObj.Remark.length > 0
                ? listItemObj.Remark.split(";")
                : [];
            if (item.Remark) remarkArr.push(item.Remark);
            listItemObj.Remark = remarkArr.join(";");
          } else {
            timeListObj[item.CreateTime].list.push(item);
          }
          timeListObj[item.CreateTime].smallPrice = this.$calc.add(
            timeListObj[item.CreateTime].smallPrice,
            this.$calc.multiply(item.num, item.Price)
          );
          // timeListObj[item.CreateTime].smallPrice += item.num * item.Price;
          timeListObj[item.CreateTime].smallNum += item.num;
        }
      });
      this.typeFoodsListObj = typeListObj;
      this.timeFoodsListObj = timeListObj;
      this.commodityInformation = this.typeFoodsListObj;
    },
    handleGetFoodsNum(foodsList) {
      let all_num = 0;
      foodsList.forEach((item) => {
        all_num += item.Quantity;
      });
      return all_num;
    },
    // 查看已支付订单
    handleToOrderDetail(item) {
      handleLocalStorage.set("foodItemInfo", item);
      this.$router.push({ name: "FoodOrderInfo" });
    },
    handleToMicpoint() {
      this.$router.push("Micropoint");
    },
    handleShowPayPop() {
      this.showPayPop = true;
    },
    handleSubmitPay() {
      if (this.payMethodType == 2 && !this.deskCode.cardCode) {
        Notify({ type: "warning", message: "暂未绑定手牌，请先绑定手牌！" });
        return;
      }
      if (this.payMethodType == 2) {
        this.isSubmitLoading = true;
        const param = {
          OrderId: this.unPayedId,
          KeyCode: this.deskCode.cardCode,
          CheckinId: this.deskCode.checkinId,
        };
        payByhandkey(param)
          .then((res) => {
            this.showPayPop = false;
            this.isSubmitLoading = false;
            this.$router.replace("PlaceOrderSuccess");
          })
          .catch((err) => {
            this.isSubmitLoading = false;
          });
      } else if (this.payMethodType == 1) {
        //在线支付
        this.$router.push({
          name: "PayList",
          query: { id: this.unPayedId, fromPage: "food" },
        });
      }
    },
  },
};
</script>
<style scoped lang="scss">
.place_order_con {
  min-height: 100vh;
  padding: 30px 30px 100px;
  box-sizing: border-box;

  .placeOrderList {
    .title_con {
      ::v-deep {
        &.van-tabs--line {
          .van-tabs__wrap {
            height: 25px !important;
            .van-tabs__nav {
              background-color: transparent !important;
            }
          }
        }
        .van-tab {
          padding: 0 4px;
          font-size: 14px;
          line-height: 20px;
          cursor: pointer;
          flex: none !important;
          margin-right: 20px;
        }
        .card_tabs_con {
          font-size: 24px;
        }
      }
    }
    h3 {
      // height: 80px;
      padding-left: 20px;
      // background: #f3f5f9;
      // line-height: 80px;
      color: #000;
      font-size: 30px;
    }
    .payed_order_list {
      color: #999;
      font-size: 24px;
      li {
        background: #fff;
        padding: 24px;
        border-radius: 16px;
        margin-bottom: 20px;
      }
    }
    .payed_order_con {
      display: flex;
      justify-content: space-between;
      align-items: center;
      > span {
        width: 35px;
        text-align: center;
        padding: 0 10px;
      }
    }
    .order_img_con {
      flex: 1;
      display: flex;
      overflow-x: auto;
      overflow-y: hidden;
      margin: 20px 0;
      p {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 20px;
        span {
          width: 120px;
          font-size: 26px;
          margin-top: 10px;
          text-align: center;
        }
      }
      img {
        flex-shrink: 0;
        width: 120px;
        height: 120px;
        border-radius: 10px;
      }
    }
  }
}
.history_footer {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 2;
  width: 100%;
  height: 120px;
  border-top: 1px solid #eee;
  background: #fff;
  box-sizing: border-box;
  padding: 0 32px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: space-around;
}
.shop_cart_con {
  padding: 20px 0;
  .cartTitle {
    display: flex;
    // display: -webkit-flex;
    align-items: center;
    justify-content: space-between;
    // box-sizing: border-box;
    padding: 0 20px;
    // width: 100%;
    height: 70px;
    font-size: 30px;
    color: #333;
  }
  .submit_btn {
    float: right;
    margin: 20px 30px 0;
    padding: 0 35px;
  }
  // .cart_goods_con {
  //   width: 100%;
  //   max-height: 50vh;
  //   overflow-y: scroll;
  //   box-sizing: border-box;
  //   padding: 14px 0px;
  // }
}
</style>
